// Module
var code = "<h2 id=\"authorized-third-party\">Authorized Third Party</h2> <p>You can authorize us to release information about your student loan account to another individual.</p> ";
// Exports
export default code;